module.exports = __webpack_public_path__ + "static/notice-title-dont-2bc858d3c0483fba83a5757845b0efd1.png";